import axios from '../../utils/axios';
import CRUD from './crud'

const tournamentCoaches = new CRUD('tournament-coaches', 'superior-judge')

export default Object.assign(
    tournamentCoaches,
    {
        reducers: {
            ...tournamentCoaches.reducers
        },

        notify: (message, filters={}) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/tournament-coaches/notify`, {
                        params: {
                            'message': message,
                            'filters': filters
                        }
                    })
                } catch (error) {
                    console.error(error);
                }
            };
        },

        postpaid: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-coaches/${id}/postpaid`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        generate: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-coaches/${id}/generate`, {}, { responseType: 'blob' })
                } catch (error) {
                    console.error(error);
                }
            };
        },

        generateInvoice: (id, options = {}) => {
            return async (dispatch) => {
                try {
                    const body = {};
                    if (options.listPosition != null && Number.isFinite(Number(options.listPosition))) {
                        body.list_position = Number(options.listPosition);
                    }
                    return axios.post(`/superior-judge/tournament-coaches/${id}/generate-invoice`, body, { responseType: 'blob' });
                } catch (error) {
                    console.error(error);
                }
            };
        },

        generateAggregatedAccounting: (tournamentCoachIds, options = {}) => {
            return async (dispatch) => {
                try {
                    const body = { tournament_coach_ids: tournamentCoachIds };
                    if (options.listPosition != null && Number.isFinite(Number(options.listPosition))) {
                        body.list_position = Number(options.listPosition);
                    }
                    return axios.post(
                        '/superior-judge/tournament-coaches/generate-aggregated-accounting',
                        body,
                        { responseType: 'blob' }
                    );
                } catch (error) {
                    console.error(error);
                }
            };
        },

        generateAggregatedInvoice: (tournamentCoachIds, options = {}) => {
            return async (dispatch) => {
                try {
                    const body = { tournament_coach_ids: tournamentCoachIds };
                    if (options.listPosition != null && Number.isFinite(Number(options.listPosition))) {
                        body.list_position = Number(options.listPosition);
                    }
                    return axios.post(
                        '/superior-judge/tournament-coaches/generate-aggregated-invoice',
                        body,
                        { responseType: 'blob' }
                    );
                } catch (error) {
                    console.error(error);
                }
            };
        },

        sendAggregatedAccountingTelegram: (tournamentCoachIds, options = {}) => {
            return async (dispatch) => {
                try {
                    const body = { tournament_coach_ids: tournamentCoachIds };
                    if (options.listPosition != null && Number.isFinite(Number(options.listPosition))) {
                        body.list_position = Number(options.listPosition);
                    }
                    return await axios.post('/superior-judge/tournament-coaches/send-aggregated-accounting-telegram', body);
                } catch (error) {
                    console.error(error);
                    throw error;
                }
            };
        },

        sendMessage: (id, message) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-coaches/${id}/message`, {message: message})
                } catch (error) {
                    console.error(error);
                }
            };
        },

        setCollected: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-coaches/${id}/collected`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        unsetCollected: (id) => {
            return async (dispatch) => {
                try {
                    return axios.delete(`/superior-judge/tournament-coaches/${id}/collected`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        setDelivered: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-coaches/${id}/delivered`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        unsetDelivered: (id) => {
            return async (dispatch) => {
                try {
                    return axios.delete(`/superior-judge/tournament-coaches/${id}/delivered`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        update: (id, data) => {
            return async (dispatch) => {
                try {
                    return axios.put(`/superior-judge/tournament-coaches/${id}`, data)
                } catch (error) {
                    console.error(error);
                }
            };
        },
    }
)
